var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeel = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#15357A",
    d: "M 159.576 484.26 C 129.046 484.26 101.8 476.855 77.822 462.026 C 53.841 447.198 34.874 426.93 20.917 401.205 C 6.96 375.464 0 346.27 0 313.567 C 0 280.864 6.96 251.857 20.917 226.578 C 34.874 200.853 53.841 180.81 77.822 166.406 C 101.8 151.578 129.046 144.172 159.576 144.172 C 184.003 144.172 205.344 148.758 223.682 157.907 C 241.982 167.075 256.811 179.919 268.152 196.51 L 268.152 30.495 L 351.856 15.74 L 351.856 476.411 L 277.283 476.411 L 268.152 429.973 C 257.684 444.376 243.727 457.015 226.281 467.928 C 209.28 478.805 187.046 484.26 159.576 484.26 Z M 177.246 411.007 C 204.268 411.007 226.281 402.078 243.299 384.206 C 260.746 365.887 269.45 342.558 269.45 314.216 C 269.45 285.876 260.746 262.769 243.299 244.896 C 226.281 226.578 204.268 217.427 177.246 217.427 C 150.632 217.427 128.619 226.355 111.174 244.228 C 93.727 262.12 85.004 285.227 85.004 313.567 C 85.004 341.891 93.727 365.237 111.174 383.538 C 128.619 401.875 150.632 411.007 177.246 411.007 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#15357A",
    cx: 443.152,
    cy: 422.959,
    r: 56.848
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deel.787fe32ba23a78c3617e12944b15bfe3.svg";